export const getMessage = (key: string): string => {
	return messages[key] ?? '';
};

export const formatMessage = (key: string, ...args: Array<string | number>): string => {
	if (typeof messages.withArguments === 'function') {
		return messages.withArguments(key, ...args);
	}
	return getMessage(key);
};
